import "./Designation.css";
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AgGridReact } from "ag-grid-react";
import AddIcon from "@mui/icons-material/Add";
import { Form, Row, Col } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import ButtonCom from "../../../components/button/button";
import { ToastContainer, toast } from "react-toastify";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import TableSkeleton from "../../../components/table/TableSkeleton.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeListPath,
  assignDesignationRolePermissionsPath,
  getRolePermissionsPath,
  getMasterRolePermissionsPath,
  saveMasterRolePermissionsPath,
  updateDesignationPath,
  deleteDesignationPath,
} from "../../../services/config";
import {
  fetchDesignationList,
  fetchModuleData,
  saveDesignation,
  initDesigState,
} from "../../../redux/slices/designationSlice";
import {
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import { HasPermission } from "../../../services/hasPermission";
import CustomPagination from "../../../components/CustomPagination";
import RolePermission from "../../../components/RolePermission";
import { useGlobalToast } from "../../../stopOldToastGlobally";

const animatedComponents = makeAnimated();

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const Designation = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
const toast = useGlobalToast(); 
  const gridRef = useRef();

  const dispatch = useDispatch();
  const state = useSelector((state) => state.designation);
  const commonState = useSelector((state) => state.common);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectError, setSelectError] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [moduleList, setModuleList] = useState([]);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const fetchList = useCallback(() => {
    dispatch(fetchDesignationList(user.user_id));
    dispatch(fetchModuleData());
  }, []);

  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    if (state.desGetSuccess) {
      const newArr = state.desGetData.map((v) => {
        return { value: v.moduleId, label: v.module_name };
      });
      setModuleList(newArr);
    }
    if (state.desGetError) {
    }
  }, [state.desGetSuccess, state.desGetError]);

  useEffect(() => {
    if (state.desigSuccess) {
      setDesignationList(state.desigData);
    }
  }, [state.desigSuccess, state.desigError]);

  const [saveData, setSaveData] = useState({
    userId: user.user_id,
    designationId: null,
    designationName: "",
    modules: [],
  });

  const handleClickOpen = () => {
    setPermissions([]);
    setOpen(true);
    fetchRolePermissions(null);
  };

  const handleClose = () => {
    setSaveData({
      ...saveData,
      designationName: "",
      modules: [],
    });
    setSavedModuleList([]);
    setIsEdit(false);
    setValidated(false);
    setSelectError(false);
    setOpen(false);
  };

  const inputHandleChange = (e) => {
    const {
      target: { value },
    } = e;
    setSaveData({
      ...saveData,
      designationName: value,
    });
  };

  const handleChange = (event) => {
    setSaveData({
      ...saveData,
      modules: event,
    });
    setSelectError(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (saveData.modules.length < 1) {
      setSelectError(true);
    }
    if (form.checkValidity() === false) {
      setValidated(true);
      return false;
    } else {
      const module = saveData.modules.map((v) => v.value).toString();
      let data = {
        userId: user.user_id,
        designationName: saveData.designationName,
        modules: "",
      };
      dispatch(saveDesignation(data));
      setSaveData({
        ...saveData,
        designationName: "",
        modules: [],
      });
      handleClose();
    }
  };

  useEffect(() => {
    if (state.desSuccess) {
      toast.success(state.desMessage);
      dispatch(fetchDesignationList(user.user_id));
      dispatch(initDesigState());
    }
    if (state.desError) {
      toast.error(state.desMessage);
      dispatch(fetchDesignationList(user.user_id));
      dispatch(initDesigState());
    }
  }, [state.desSuccess, state.desError]);

  // DELETE UPDATE RECORD FUNCTION ===================
  const [show, setShow] = useState(false);

  const [savedModuleList, setSavedModuleList] = useState([]);
  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isEdit, setIsEdit] = useState(false);
  
  const handleEdit = (row) => {
    // const savedModules = row.modules.split(",");
    // const brnIndex = savedModules.map((v) => {
    //   return moduleList.findIndex((obj) => {
    //     return parseInt(obj.value) === parseInt(v);
    //   });
    // });
    // setSavedModuleList(brnIndex);
    setPermissions([]);
    setIsEdit(true);
    setSaveData({
      ...saveData,
      designationId: row.designationId,
      designationName: row.designation_name,
      modules: [],
    });

    fetchRolePermissions(row.designationId);
    setOpen(true);
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    let d = {
      path: updateDesignationPath,
      data: saveData,
    };
    dispatch(commonSaveData(d));
  };

  // Delete functions
  const [delId, setDelId] = useState(null);
  const handleDelete = (row) => {
    setDelId(row.designationId);
    handleShow();
  };
  const handleDeleteSubmit = () => {
    let d = {
      path: deleteDesignationPath,
      data: {
        userId: user.user_id,
        designationId: delId,
      },
    };
    dispatch(commonSaveData(d));
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      setOpen(false);
      setShow(false);
      fetchList();
      setDelId(null);
      setIsEdit(false);
      handleModalClose1();
      setFilteredPermissions([]);
      setPermissions([]);
      dispatch(initCommonState());
    }
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      setOpen(false);
      setShow(false);
      fetchList();
      setDelId(null);
      setIsEdit(false);
      handleModalClose1();
      setFilteredPermissions([]);
      setPermissions([]);
      dispatch(initCommonState());
    }
  }, [commonState, dispatch]);
  // =================================================

 const heading = [
  {
    headerName: "S.No",
    field: "sno",
    width: 80,
    sortable: false,
    filter: false,
    suppressMovable: true,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "500",
      padding: "0px",
    },
    headerClass: "text-center",
    valueGetter: (params) => {
      if (!params || !params.node) return '';
      
      const api = params.api;
      const rowIndex = params.node.rowIndex;
      
      if (!api) return rowIndex + 1;
      
      try {
        const paginationEnabled = api.isPaginationActive();
        if (paginationEnabled) {
          const currentPage = api.paginationGetCurrentPage();
          const pageSize = api.paginationGetPageSize();
          return (currentPage * pageSize) + rowIndex + 1;
        }
        return rowIndex + 1;
      } catch (error) {
        return rowIndex + 1;
      }
    },
    comparator: (valueA, valueB, nodeA, nodeB) => {
      const indexA = nodeA?.rowIndex ?? 0;
      const indexB = nodeB?.rowIndex ?? 0;
      return indexA - indexB;
    }
  },
  {
    headerName: "Designation",
    field: "designation_name",
    flex: 1,
    minWidth: 150,
    cellStyle: { 
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      paddingLeft: "15px",
    },
    headerClass: "text-left",
  },
  {
    headerName: "Status",
    field: "status",
    width: 120,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    headerClass: "text-center",
    cellRenderer: (rowData) => {
      return rowData.data.status == 1 ? "Active" : "InActive";
    },
  },
  {
    headerName: "Action",
    width: 150,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px",
    },
    headerClass: "text-center",
    cellRenderer: (rowData) => {
      return (
        <div 
          style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            gap: "12px",
            width: "100%",
            height: "100%",
            padding: "0px",
            margin: "0px",
          }}
        >
          {HasPermission("Designations", "edit") && (
            <PiPencilSimpleLineBold
              style={{ 
                cursor: "pointer", 
                fontSize: "24px",
                color: "#666",
                margin: "0px",
                padding: "0px",
              }}
              className="edit-icon"
              onClick={() => {
                handleEdit(rowData.data);
              }}
            />
          )}

          {HasPermission("Designations", "delete") && (
            <RiDeleteBinLine 
              className="delete-icon"
              style={{ 
                cursor: "pointer", 
                fontSize: "24px", 
                color: "red",
                margin: "0px",
                padding: "0px",
              }}
              onClick={() => handleDelete(rowData.data)}
            />
          )}

          {!HasPermission("Designations", "approve") &&
            !HasPermission("Designations", "reject") &&
            !HasPermission("Designations", "edit") &&
            !HasPermission("Designations", "delete") &&
            <span style={{ margin: "0px", padding: "0px" }}>-</span>}
        </div>
      );
    },
  },
];

  {
    /* {HasPermission("Designations","create") &&(
              <MdOutlineAssignmentTurnedIn
                style={{
                  cursor: "pointer",
                  fontSize: 25,
                  color: "#58d68d",
                }}
                onClick={() => {
                  handleShow1();
                  handleAssignId(rowData.data);
                }}
              />
            )} */
  }

  const [designationId, setDesignationId] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);

  const [outletName, setOutletName] = useState("");

  const [permissions, setPermissions] = useState([]);
  const [filteredPermissions, setFilteredPermissions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const getEmployeeList = useCallback((id) => {
    const data = {
      path: getEmployeeListPath,
      data: {
        userId: user.user_id,
        designationId: id,
      },
    };
    dispatch(commonSaveDataOne(data));
  }, []);

  const fetchRolePermissions = useCallback((designationId) => {
    let data = {
      path: getMasterRolePermissionsPath,
      data: {
        staffId: "",
        userId: user.user_id,
        roleId: "",
        designationId: designationId,
      },
    };
    dispatch(commonSaveDataOne(data));
  }, []);

  useEffect(() => {
    if (commonState.commonSuccessOne) {
      setPermissions(commonState.commonDataOne);
      setFilteredPermissions(commonState.commonDataOne);

      const allChecked = commonState.commonDataOne.every((row) => {
        if (row.isMainModule !== "1" && row.view !== "1") return false;

        return [
          "create",
          "edit",
          "delete",
          "export",
          "approve",
          "reject",
        ].every((key) => {
          const val = row[key];
          return val === "1" || val === null;
        });
      });
      setSelectAll(allChecked);

      dispatch(initCommonState());
    }
    if (commonState.commonErrorOne) {
      toast.error(commonState.commonMessageOne);
    }
  }, [commonState, dispatch]);

  const handleAssignId = (data) => {
    setDesignationId(data.designationId);
    setOutletName(data.designation_name);
    fetchRolePermissions(data.designationId);
    // getEmployeeList(data.designationId);
  };

  const [show1, setShow1] = useState(false);

  const handleModalClose1 = () => {
    setShow1(false);
    setFilteredPermissions([]);
    setPermissions([]);
  };
  const handleShow1 = () => setShow1(true);

  const preSubmit = () => {
    let elem = document.querySelector("#subId");
    if (elem) {
      elem.click();
    }
  };

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "transparent",
      }}
    >
      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Designation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div className="branch-container" style={{ marginTop: "-10px" }}>
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to="/setting/" className="icon-color">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company Designation"
            />
          }
          button={
            HasPermission("Designations", "create") && (
              <ButtonCom
                type="button"
                class_name={"universal-btn border-radius-8px"}
                text="Add Designation"
                url_or_onclick={handleClickOpen}
                icon={<AddIcon style={{position: "relative", top: "-2px"}} />}
                width={""}
              />
            )
          }
       body={
  <>
    <div
      className="ag-theme-quartz custom-grid mt-2"
      style={{ 
        height: "calc(100vh - 250px)", 
        width: "100%",
        padding: "0 20px",
        '--ag-cell-horizontal-padding': '8px',
        '--ag-header-cell-horizontal-padding': '8px',
        '--ag-row-height': '48px',
        '--ag-header-height': '48px',
        '--ag-border-color': '#e0e0e0',
        '--ag-header-background-color': '#f8f9fa',
        '--ag-odd-row-background-color': '#fafafa',
        '--ag-header-column-separator-display': 'block',
        '--ag-header-column-separator-height': '100%',
        '--ag-header-column-separator-width': '1px',
        '--ag-header-column-separator-color': '#e0e0e0',
      }}
    >
      <AgGridReact
        rowData={Array.isArray(designationList) ? designationList : []}
        columnDefs={heading}
        domLayout="autoHeight" // Fixed: changed from "omLayout" to "domLayout"
        pagination={true}
        paginationPageSize={paginationPageSize}
        paginationPageSizeSelector={paginationPageSizeSelector}
        onGridReady={onGridReady}
        rowHeight={48}
        headerHeight={48}
        suppressCellFocus={true}
        defaultColDef={{
          resizable: true,
          sortable: false,
          filter: false,
          suppressMenu: true,
        }}
        onFirstDataRendered={(params) => {
          params.api.sizeColumnsToFit();
        }}
      />
    </div>
    <div className="d-flex align-items-center justify-content-between custom-pagination px-4 mt-3">
      {gridApi && <CustomPagination gridApi={gridApi} />}
    </div>
  </>
}
        />
      </div>

      {/* <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">
              {" "}
              {isEdit ? " Update Designation" : " Add Designation"}
            </span>
          </div>
          <button
            className="universal-btn"
            onClick={preSubmit}
            style={{ width: "100px" }}
          >
            {isEdit ? " Update" : "Add"}
          </button>
        </DialogTitle>

        <div
          style={{
            height: "120px",
          }}
        >
          <Form
            noValidate
            validated={validated}
            onSubmit={isEdit ? handleEditSubmit : handleSubmit}
          >
            <Row>
                <Col sm="12">
            <Form.Group className="mb-2 p-3">
              <Form.Label className="color-white">Designation</Form.Label>
              <Form.Control
                type="text"
                name="designationName"
                value={saveData.designationName}
                placeholder="Enter Designation Name"
                onChange={inputHandleChange}
                required
                className="universal-input-one"
              />
              <Form.Control.Feedback type={"invalid"}>
                Please provide valid designation name.
              </Form.Control.Feedback>
            </Form.Group>
            </Col>
            
            <Col sm="12">
                  <Form.Group as={Col} controlId="my_multiselect_field">
                    <Form.Label className="color-white">
                      Select Modules
                    </Form.Label>
                    <FormControl style={{ width: "100%" }} required>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        defaultValue={savedModuleList.map((r) => moduleList[r])}
                        value={saveData.modules}
                        isMulti
                        options={moduleList}
                        onChange={handleChange}
                        styles={customStyles}
                      />
                    </FormControl>
                    {selectError && (
                      <span style={{ color: "#dc4345", fontSize: "14px" }}>
                        Please provide valid module name.
                      </span>
                    )}
                  </Form.Group>
                </Col>
            </Row>

            <Button
              variant="contained"
              color="info"
              type="submit"
              style={{
                display: "none",
                height: "30px",
                width: "100px",
                fontWeight: "bold",
                fontSize: "14px",
                lineHeight: "30px",
              }}
              className="universal-btn"
              id="subId"
            >
              Save
            </Button>
          </Form>
        </div>
      </Dialog> */}

      <Dialog
        fullWidth={true}
        // maxWidth={"xl"}
        open={open}
        onClose={handleClose}
        fullScreen
      >
        {/* <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">Role Permission</span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <button
              onClick={toggleSelectAll}
              style={{
                background: selectAll ? "#d63031" : "#00b894",
                color: "white",
                padding: "6px 12px",
                border: "none",
                borderRadius: "12px",
                fontWeight: "bold",
                fontSize: "13px",
              }}
            >
              {selectAll ? "Unselect All" : "Select All"}
            </button>

            <button className="universal-btn" onClick={savePermission}>
              Save Changes
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div
            className="ag-theme-quartz custom-grid mt-3"
            style={{
              height: "calc(100vh - 120px)",
              width: "100%",
            }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={
                permissions?.length > 0
                  ? permissions.map((p) => ({ ...p }))
                  : []
              }
              columnDefs={permissionHeading}
              immutableData={true} // Important!
              getRowNodeId={(data) => data.id}
              suppressCellFocus={true}
            />
          </div>

          
        </DialogContent> */}

        {permissions.length > 0 ? (
          <RolePermission
            user={user}
            designationId={designationId}
            saveMasterRolePermissionsPath={saveMasterRolePermissionsPath}
            dispatch={dispatch}
            commonSaveData={commonSaveData}
            initialData={permissions}
            handleModalClose1={handleClose}
            staffId={""}
            isPopup={true}
            isEdit={isEdit}
            designationData={saveData}
          />
        ) : (
          <DialogContent>
            <TableSkeleton />
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
};

const customStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 1600,
    width: "340px", // Higher than MUI Dialog (1300)
  }),

  control: (provided, state) => ({
    ...provided,
    border: "1px solid gray", // Remove border
    borderRadius: "12px", // Remove border
    boxShadow: "none", // Remove shadow on focus
    backgroundColor: "transparent",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "gray" // Hover color
      : state.isSelected
      ? "#90caf9" // Selected color
      : "#1e1d2e", // Default
    color: "#fff",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#1e1d2e",
  }),
};

export default Designation;
